import {createStore, withProps} from '@ngneat/elf';
import { withEntities } from '@ngneat/elf-entities';
import { withRequestsStatus } from '@ngneat/elf-requests';

import {AuditInformation, AuditInformationCreatedFromStepEnum} from './audits-information.model';
export interface AuditsInformationState {
    step: AuditInformationCreatedFromStepEnum;
}

export const auditsInformationStore = createStore(
  { name: 'audits-information' },
    withProps<AuditsInformationState>({
        step: AuditInformationCreatedFromStepEnum.PREAUDIT
    }),
  withEntities<AuditInformation>(),
  withRequestsStatus()
);
